/* @flow */
import fs from '@/services/fs'
import store from '@/store'
export default class BookArchiver {
  selectedBooks: Array<string>
  currentStatus: string

  constructor() {
    this.selectedBooks = []
    this.currentStatus = 'READY_TO_ARCHIVE'
  }

  addToSelected(bookId: string): void {
    this.selectedBooks.push(bookId)
  }

  removeFromSelected(bookId: string): void {
    let index = this.selectedBooks.indexOf(bookId)

    this.selectedBooks.splice(index, 1)
  }

  setCurrentStatus(status: string): void {
    this.currentStatus = status
  }

  cancelArchiving(): void {
    this.clearStatus()
  }

  clearStatus(): void {
    this.selectedBooks = []
    this.currentStatus = 'READY_TO_ARCHIVE'
  }

  async archiveSelected(): void {
    this.currentStatus = 'ARCHIVING'
    await Promise.all(this.selectedBooks.map(async book => {
      await fs.removeBook(book)
    }))
    await store.dispatch('book/getSavedBooks')
    this.clearStatus()
  }
}
